module.exports = __webpack_public_path__ + "549bbb858c33fe52876f69f6d950084e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/lokalrunde-2.jpg
// module id = 524
// module chunks = 0